import {
  type DashRouteType,
  URL_RETAILER_SCOPED,
  URL_SITE_SCOPED,
} from '@retailer-platform/dashboard/routing'

// Site-scoped parent route. It carries `/sites/:storeConfigId`, so the parent <Route> puts
// `storeConfigId` into the React Router match that descendants read via useParams(). DashRoute renders
// a route's <RetailerScopeWrapper> *above* that route's own <Route> (see dash-route/DashRoute.tsx), so
// the scope wrapper only sees params from an ancestor route — it cannot see its own `:storeConfigId`.
// Nesting the editor under this site-scoped parent (mirroring the storefront domain) is what lets the
// wrapper resolve the store config instead of throwing on an undefined param.
const URL_CART_ASSISTANT = `${URL_RETAILER_SCOPED}/cart-assistant${URL_SITE_SCOPED}`
const URL_CART_ASSISTANT_EDITOR = `${URL_CART_ASSISTANT}/editor`
// @hygen:inject scoped-urls

export type DashRouteSet = DashRouteType<'cart-assistant' | 'cart-assistant-editor'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'cart-assistant': URL_CART_ASSISTANT,
  'cart-assistant-editor': URL_CART_ASSISTANT_EDITOR,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
